import { useNavigate } from "react-router-dom";
import { YStack, XStack, Text, View } from "tamagui";
import { RiArrowLeftSLine, RiCoupon2Line, RiSearch2Line, RiArrowRightSLine } from "react-icons/ri";
import Header from "@components/layout/Header";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import { colors } from "@styles/colors";

/**
 * 既有客戶入口：選擇「有客戶序號直接連結」或「沒有序號，自動查找」。
 *  - 有序號 → /register/step2/inviteCode（既有客戶序號註冊流程）
 *  - 沒序號 → /register/new（手機/地址自動配對瓦斯行流程）
 */
const ExistingCustomer = () => {
  const navigate = useNavigate();

  return (
    <YStack height="100dvh" width="100vw" background={colors.bg}>
      <Header>
        <XStack ai="center" onPress={() => navigate("/")} cursor="pointer" mb="$2">
          <View mr="$1">
            <RiArrowLeftSLine size={20} color={colors.light} />
          </View>
          <Text color="rgba(255,255,255,0.75)" fontSize={13}>
            返回
          </Text>
        </XStack>
        <Text color={colors.light} fontSize={22} fontWeight="800">
          既有客戶
        </Text>
        <Text color="rgba(255,255,255,0.75)" fontSize={13} mt="$1">
          選擇您連結瓦斯行的方式
        </Text>
      </Header>

      <RadiusContentWrapper>
        <YStack gap={12}>
          {/* 有序號 */}
          <XStack
            background={colors.light}
            borderRadius={16}
            p="$4"
            borderWidth={1.5}
            borderColor="#BFDBFE"
            ai="center"
            gap="$3"
            position="relative"
            overflow="hidden"
            cursor="pointer"
            onPress={() => navigate("/register/step2/inviteCode")}>
            {/* 最快標記 */}
            <View
              position="absolute"
              t={0}
              r={0}
              px="$2.5"
              py="$1"
              borderBottomLeftRadius={10}
              style={{ background: "linear-gradient(135deg, #F59E0B, #EA580C)" }}>
              <Text fontSize={10} fontWeight="800" color={colors.light} letterSpacing={0.5}>
                最快
              </Text>
            </View>
            <View width={46} height={46} borderRadius={12} ai="center" jc="center" className="primary-bg-gradient">
              <RiCoupon2Line size={24} color={colors.light} />
            </View>
            <YStack flex={1}>
              <Text fontSize={16} fontWeight="700" color={colors.primaryText} mb="$1">
                我有客戶序號
              </Text>
              <Text fontSize={12} color={colors.sub} lineHeight={18}>
                瓦斯行提供的序號,可直接連結帳戶
              </Text>
            </YStack>
            <RiArrowRightSLine size={22} color={colors.primary} />
          </XStack>

          {/* 沒序號，自動查找 */}
          <XStack
            background={colors.light}
            borderRadius={16}
            p="$4"
            borderWidth={1}
            borderColor={colors.borderLight}
            ai="center"
            gap="$3"
            cursor="pointer"
            onPress={() => navigate("/register/new")}>
            <View width={46} height={46} borderRadius={12} ai="center" jc="center" background={colors.primaryBg}>
              <RiSearch2Line size={24} color={colors.primary} />
            </View>
            <YStack flex={1}>
              <Text fontSize={16} fontWeight="700" color={colors.grayDark} mb="$1">
                沒有序號,自動查找
              </Text>
              <Text fontSize={12} color={colors.sub} lineHeight={18}>
                用手機與地址自動配對您的瓦斯行
              </Text>
            </YStack>
            <RiArrowRightSLine size={22} color={colors.hint} />
          </XStack>

          {/* 提示 */}
          <XStack background={colors.bg} borderRadius={12} p="$3.5" gap="$2.5" ai="center" borderWidth={1} borderColor={colors.border}>
            <Text fontSize={16}>💡</Text>
            <YStack flex={1}>
              <Text fontSize={12} color={colors.sub} fontWeight="500" lineHeight={18}>
                不確定有沒有序號?
              </Text>
              <Text fontSize={12} color={colors.sub} fontWeight="500" lineHeight={18}>
                直接選「自動查找」,系統會幫您配對
              </Text>
            </YStack>
          </XStack>
        </YStack>
      </RadiusContentWrapper>
    </YStack>
  );
};

export default ExistingCustomer;
